export default __webpack_public_path__ + "static/media/Who_We_Are_1.e57ce54c.png";